import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import SEO from "@/components/base/SEO";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategoryNav from "./components/CategoryNav";
import HotVideos from "./components/HotVideos";
import LatestContent from "./components/LatestContent";
import NewsletterSection from "./components/NewsletterSection";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname]);

  const homeSchema = [
    {
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: "黑料吃瓜 - 高清视频在线观看",
      description:
        "黑料吃瓜网提供黑料吃瓜在线观看高清视频、短视频和最新视频，支持在线播放，每日更新吃瓜内容。",
      url: "https://wx1121.cn/",
      isPartOf: {
        "@type": "WebSite",
        name: "黑料吃瓜",
        url: "https://wx1121.cn/",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "首页",
          item: "https://wx1121.cn/",
        },
      ],
    },
  ];

  return (
    <>
      <SEO
        title="黑料吃瓜 - 黑料吃瓜在线观看·黑料吃瓜视频高清播放"
        description="黑料吃瓜网提供黑料吃瓜在线观看高清视频、短视频和最新视频，支持在线播放，每日更新吃瓜内容。黑料吃瓜在线、黑料吃瓜视频、黑料吃瓜高清视频、黑料吃瓜免费视频尽在黑料吃瓜网。"
        keywords="黑料吃瓜在线,黑料吃瓜在线观看,黑料吃瓜视频,黑料吃瓜高清视频,黑料吃瓜免费视频,黑料吃瓜短视频,黑料吃瓜在线播放,黑料吃瓜最新视频,黑料吃瓜网在线观看,黑料吃瓜网在线"
        canonicalUrl="https://wx1121.cn/"
        schema={homeSchema}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryNav />
          <HotVideos />
          <LatestContent />
          <NewsletterSection />
        </main>
        <Footer />
      </div>
    </>
  );
}